module.exports = __webpack_public_path__ + "static/media/bruvi-mobiles-tiny.28da82ee.jpg";